import { render, staticRenderFns } from "./adjuntarPdf.vue?vue&type=template&id=05ed8058&scoped=true"
import script from "./adjuntarPdf.vue?vue&type=script&lang=js"
export * from "./adjuntarPdf.vue?vue&type=script&lang=js"
import style0 from "./adjuntarPdf.vue?vue&type=style&index=0&id=05ed8058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed8058",
  null
  
)

export default component.exports